function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#home_svg__clip0_70_1899)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.12,
  d: "M22 15v-3.155c0-1.412 0-2.118-.18-2.77a5.001 5.001 0 00-.772-1.606c-.397-.548-.948-.989-2.05-1.871l-2-1.6c-1.784-1.427-2.676-2.14-3.665-2.414a5 5 0 00-2.666 0c-.99.274-1.881.987-3.665 2.414l-2 1.6C3.9 6.48 3.35 6.921 2.952 7.468a5 5 0 00-.772 1.607C2 9.727 2 10.433 2 11.845V15c0 1.861 0 2.792.245 3.545a5 5 0 003.21 3.21C6.208 22 7.139 22 9 22v-7c0-.932 0-1.398.152-1.765a2 2 0 011.083-1.083C10.602 12 11.068 12 12 12c.932 0 1.398 0 1.765.152a2 2 0 011.083 1.083C15 13.602 15 14.068 15 15v7c1.861 0 2.792 0 3.545-.245a5 5 0 003.21-3.21C22 17.792 22 16.861 22 15z",
  fill: "#D8DAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 22v-7c0-.932 0-1.398-.152-1.765a2 2 0 00-1.083-1.083C13.398 12 12.932 12 12 12v0c-.932 0-1.398 0-1.765.152a2 2 0 00-1.083 1.083C9 13.602 9 14.068 9 15v7M7.002 3.998l-2 1.6C3.9 6.48 3.35 6.92 2.952 7.468a5 5 0 00-.772 1.607C2 9.727 2 10.433 2 11.845V14c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C5.8 22 7.2 22 10 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185C22 18.2 22 16.8 22 14v-2.155c0-1.412 0-2.118-.18-2.77a5 5 0 00-.772-1.607c-.397-.547-.948-.988-2.05-1.87l-2-1.6c-1.784-1.427-2.676-2.14-3.665-2.414a5 5 0 00-2.666 0c-.99.274-1.881.987-3.665 2.414z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "home_svg__clip0_70_1899"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgHome;